import { render, staticRenderFns } from "./SubData.vue?vue&type=template&id=40075198&scoped=true&"
import script from "./SubData.vue?vue&type=script&lang=js&"
export * from "./SubData.vue?vue&type=script&lang=js&"
import style0 from "./SubData.vue?vue&type=style&index=0&id=40075198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40075198",
  null
  
)

export default component.exports